module.exports = __webpack_public_path__ + "img/yingyezhizhao.1acb8541.png";